module.exports = __webpack_public_path__ + "static/media/Viserys Targaryen 1.22218764.jpg";